module.exports = __webpack_public_path__ + "88862caae70be4908361f0d38942c3b6.MP3";